// 比较页面路由
export default [
  //产品选型比较列表页面
  {
    path: "/:lang/Compare4Select/Index",
    name: "Compare4Select/Index",
    alias: [
      "/:lang/Compare4Select/Index",
      "/:lang/Compare4Select/Index",
      "/:lang/Compare4Select/Index",
      "/:lang/Compare4Select/Index",
      "/:lang/Compare4Select/Index",
    ],
    meta: {
      title: "产品选型比较列表",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/Compare/Compare4Select.vue"),
  },
  //产品比较列表页面
  {
    path: "/:lang/Compare/Index",
    name: "Compare/Index",
    alias: [
      "/:lang/Compare/Index",
      "/:lang/Compare/Index",
      "/:lang/Compare/Index",
      "/:lang/Compare/Index",
      "/:lang/Compare/Index",
    ],
    meta: {
      title: "比较列表",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/Compare/CompareList.vue"),
  },
];
